import styled from 'styled-components'

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
  justify-content: center;
  align-items: center;
  width: 100%;
`
export default ContentArea